import { createContext, useCallback, useEffect, useState } from "react";
import Env from "../../../Env";
import { TableDataLoader, TableDataLoaderParams } from "./Table";




export interface TableContextType{
    expandIdx?: string
    toggleExpandIdx: (idx: string) => void
    data: any[]
    setDataLoader: (dataloader: TableDataLoader) => void
    refresh: () => void
    loading: boolean
    setLoading: (laoding: boolean) => void
    total: number
    page: number
    pageSize: number
    setPagination: (page: number, pageSize: number) => void
    changeTotal: (total: number) => void
}

export const TableContext = createContext<TableContextType>({
    data: [],
    expandIdx: undefined,
    toggleExpandIdx: function (idx: any): void {
        throw new Error("Function not implemented.");
    },
    setDataLoader: function (dataloader: TableDataLoader): Promise<any[]> {
        throw new Error("Function not implemented.");
    },
    refresh: function (): void {
        throw new Error("Function not implemented.");
    },
    loading: false,
    setLoading: function (laoding: boolean): void {
        throw new Error("Function not implemented.");
    },
    setPagination: function (page: number, pageSize: number): void {
        throw new Error("Function not implemented.");
    },
    total: 0,
    page: 1,
    pageSize: 10,
    changeTotal: function (total: number): void {
        throw new Error("Function not implemented.");
    },
})


export const useTableInstance = (): TableContextType => {

    const [expandIdx, setExpandIdx] = useState<string>()
    const [data, setData] = useState<any[]>([])
    const [loading, setLoading] = useState<boolean>(false)
    let dataLoader: TableDataLoader
    const [page, setPage] = useState<number>(1)
    const [pageSize, setPageSize] = useState<number>(10)
    const [total, setTotal] = useState<number>(0)

    const toggleExpandIdx = (idx: string) => {
        
        setExpandIdx(current => {
            if(current === idx) return undefined;
            return idx;
        })
    }

    const setDataLoader = (_dataLoader: TableDataLoader) => {
        dataLoader = async (params: TableDataLoaderParams) => {
            setLoading(true)
            try{
                return await _dataLoader(params);
            }finally{
                setLoading(false)
            }
        }
    }

    const refresh = () => {
        console.log(`refresh, page: ${page}, pageSize: ${pageSize}`)
        dataLoader({page, pageSize}).then(setData)
    }

    const setPagination = (page: number, pageSize: number) => {
        setPage(page)
        setPageSize(pageSize)
        dataLoader({page, pageSize}).then(setData)
    }

    const changeTotal = (total: number) => {
        setTotal(total)
    }

    useEffect(() => {
        Env.DEBUG && console.log("expandIdx change, expandIdx: ", expandIdx);
    }, [expandIdx])

    return {
        data,
        expandIdx,
        toggleExpandIdx,
        setDataLoader,
        refresh,
        loading,
        setLoading,
        total,
        page,
        pageSize,
        setPagination,
        changeTotal,
    }

}